/** @format */

import styled from "styled-components";
import { FlexBox } from "../../layouts/FlexBox";
import InquiryItemElement from "./InquiryItemElement";
import { colors, mixins } from "../../../css/variables";
import noticeImg from "../../../images/inquiryNaviBar.svg";
import { MouseEventHandler } from "react";
import { inquiryCommentArrayType, inquiryDataArrayType } from "../../../constance/providerTypeModel";

const InquiryCommentWrapper = styled.div`
  max-width: 500px;
  position: fixed;
  right: 0px;
  bottom: 0px;
  background-color: ${colors.themeColor("background_whitegray")};
  border-radius: 4px 4px 0px 0px;
  z-index: 1000;
  ${mixins.screenUnder()} {
    display: none;
  }
`;
const InquiryModalWrapper = styled.div`
  padding: 10px 10px 10px 20px;
  background-color: ${colors.themeColor("background_whitegray")};
`;
const InquiryModalP = styled.p`
  margin-bottom: 0px;
  color: ${colors.themeColor("primary_dark")};
`;
const InquiryCountWrapper = styled.span`
  background-color: ${colors.themeColor("primary_dark")};
  color: ${colors.themeColor("text_white")};
  border-radius: 20px;
  width: 20px;
  height: 20px;
  display: inline-block;
  text-align: center;
`;
const ToggleBtnStyle = styled.div`
  width: 26px;
  height: 26px;
  margin-left: auto;
  cursor: pointer;
`;
const NoticeImgStyle = styled.div`
  background-color: ${colors.themeColor("background_whitegray")};
  text-align: center;
`;
const InquirySlideInElement = ({
  inquiryCount,
  naviToggleChangeHandler,
  naviFlag,
  InquiryCommentData,
  serchInquiryData,
  accordionNum,
}: {
  inquiryCount: { active: number };
  naviToggleChangeHandler: MouseEventHandler<HTMLElement>;
  naviFlag?: boolean;
  InquiryCommentData: inquiryDataArrayType;
  serchInquiryData: Function;
  accordionNum: number | null;
}) => {
  return (
    <InquiryCommentWrapper>
      <InquiryModalWrapper>
        <FlexBox>
          <InquiryModalP>
            お申し込みの不備をご確認ください <InquiryCountWrapper>{inquiryCount.active}</InquiryCountWrapper>
          </InquiryModalP>
          <ToggleBtnStyle onClick={naviToggleChangeHandler}>
            <NoticeImgStyle>
              <img src={noticeImg} alt="noticeImg" />
            </NoticeImgStyle>
          </ToggleBtnStyle>
        </FlexBox>
      </InquiryModalWrapper>
      {naviFlag &&
        InquiryCommentData.map((data: inquiryCommentArrayType, index: number) => {
          // ステータスがCLOSEDの場合リターン
          if (serchInquiryData(data[0].ticket_id).status === "CLOSED") return <div key={index}></div>;
          return (
            <div key={index}>
              <InquiryItemElement
                inquiryData={serchInquiryData(data[0].ticket_id)}
                inquiryComment={data}
                accordionOpen={accordionNum}
                navigation
              />
            </div>
          );
        })}
    </InquiryCommentWrapper>
  );
};

export default InquirySlideInElement;
